/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/emailAttachments/invoiceImageItem"/>
import { FileItem, UploadProgressEnum } from "@medius/ui-controls";
import * as React from "react";
import { IInvoiceImageDto } from "./interfaces";
const rest = require("Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest");

async function loadFirstImageFromBackend(documentId: number, documentType: string): Promise<IInvoiceImageDto | null> {
    const files = await new Promise<{Name: string, Hash: string, FileSize: number}[]>((resolve, reject) => {
        rest.get("remedium-api/HashFilesService",
            "GetImageHashFilesWithNames",
            {
                entityId: documentId,
                entityType: documentType
            })
            .done((f: any) => resolve(f ?? []))
            .fail((err: any) => reject(err));
    });

    if (Array.isArray(files) && files.length > 0) {
        const first = files[0];
        return { name: first.Name, hash: first.Hash , fileSize: first.FileSize };
    }
    return null;
}

type InvoiceImageItemProps = {
    documentId: number;
    documentType: string;
};

export const InvoiceImageItem = ({documentId, documentType}: InvoiceImageItemProps) => {
    const [invoiceImage, setInvoiceImage] = React.useState<IInvoiceImageDto>();

    React.useEffect(() => {
        const controller = new AbortController();

        (async () => {
            try {
                const img = await loadFirstImageFromBackend(documentId, documentType);
                if (!controller.signal.aborted) {
                    setInvoiceImage(img);
                }
            } catch (err) {
                if (!controller.signal.aborted) {
                    setInvoiceImage(null);
                }
            }
        })();

        return () => {
            controller.abort();
        };
    }, [documentId, documentType]);


    return (
        <>
            {invoiceImage &&
                <FileItem
                    name={invoiceImage.name}
                    progressStatus={UploadProgressEnum.Uploaded}
                    size={invoiceImage.fileSize}
                />
            }
        </>
    );
};